import { portalText } from "../../i18n/portal.js";
/**
 * The phone-test helpers the test card uses (`test-chat-panel.tsx`, `phone-test-call.ts`) and the
 * person-data request reuses: the phone as typed, normalised; the example for the account's country;
 * an unanswered "Call me" in words.
 *
 * AMENDED 2026-10-09 (design sync, unit A at unit D's request): the voice test FORM that lived here —
 * the Agent's Test tab and the Test console, with its three directions — is gone. Both surfaces are the
 * one test card now (`TestChatPanel`, `layout="card"`), whose My phone / Call me and Browser voice modes
 * run the same tests; nothing drew the form any more. The helpers keep this module's name so their
 * importers do not move.
 */
/** Separators a person types in a phone number; the API strips the same ones. */
const PHONE_SEPARATOR = /[\s\-().]/g;

export function normalisedPhone(raw: string): string {
  return raw.replace(PHONE_SEPARATOR, "");
}

/** The phone field's example in the account's own format (review #56): `+30 69…`. */
export function phoneExampleOf(countryCallingCode: string | null): string {
  if (countryCallingCode === "+30") return "+30 69…";
  if (countryCallingCode === null) return portalText("operations", "with_your_country_code_25dc7da2");
  return `${countryCallingCode} …`;
}

/**
 * How an "Agent calls me" test that never connected ended, in words for the tester (review 125), or
 * `null` when it connected — then the billed line says how it went.
 */
export function unansweredOutcomeOf(endReason: string | null): string | null {
  switch (endReason) {
    case "no_answer":
      return portalText("operations", "your_phone_did_not_answer_so_the_test_ended_nothing_was_ch_2e461438");
    case "busy":
      return portalText("operations", "your_phone_was_busy_or_declined_the_call_so_the_test_ended_1e37f200");
    case "carrier_failure":
    case "unreachable":
      return portalText("operations", "the_call_could_not_reach_your_phone_check_the_number_and_t_129aad39");
    case "platform_at_capacity":
      return portalText("operations", "every_free_line_was_needed_for_people_calling_in_so_wetalk_24425940");
    default:
      return null;
  }
}
